import React from 'react';
import { View, ScrollView, Text, Image } from 'react-native';

import styles from './styles';

const CardsCashback = () => {
    return (
        <ScrollView horizontal={true} showsHorizontalScrollIndicator={false}>
            <View style={styles.contentCard}>
                <View style={styles.contentHeaderCard}>
                    <Text style={styles.percentage}>15%</Text>
                    <Text style={styles.textCashback}>CASHBACK</Text>
                </View>
                <Text style={styles.descriptionCashback}>
                    Abasteça no Posto Shell pagando pouco, aproveite!
                </Text>
                <Image source={require('../../../assets/imgs/cashbackShell.png')} style={styles.imgCashback} />
                <Text style={styles.more}>Saiba mais ➞</Text>
            </View>

            <View style={styles.contentCard}>
                <View style={styles.contentHeaderCard}>
                    <Text style={styles.percentage}>30%</Text>
                    <Text style={styles.textCashback}>CASHBACK</Text>
                </View>
                <Text style={styles.descriptionCashback}>
                    O marketplace está te esperando!
                </Text>
                <Image source={require('../../../assets/imgs/cashbackMarketplace.png')} style={styles.imgCashback} />
                <Text style={styles.more}>Saiba mais ➞</Text>
            </View>

            <View style={styles.contentCard}>
                <View style={styles.contentHeaderCard}>
                    <Text style={styles.percentage}>55%</Text>
                    <Text style={styles.textCashback}>CASHBACK</Text>
                </View>
                <Text style={styles.descriptionCashback}>
                    Imperdível!
                    As delícias do Outback melhor do que nunca.
                </Text>
                <Image source={require('../../../assets/imgs/cashbackShell.png')} style={styles.imgCashback} />
                <Text style={styles.more}>Saiba mais ➞</Text>
            </View>
        </ScrollView>
    );
}

export default CardsCashback;